
// import React from 'react'
// import Container from 'react-bootstrap/Container';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import Useletter from '../Useletter';
// import Foter from '../Foter';
// function Page2() {
//   return (
//     <div>
//         <Container>
//             <Row>
//                 <Col>
//                 <div className="gift" style={{display:"flex",marginTop:"20px",}}>
//                 <a href="/corporate" class="back-button" style={{textDecoration:"none", color:"inherit",fontSize:"20px",}}>← </a>
//                 <h2 style={{fontFamily:"Alata,sans serif",fontSize:"25px",color:"#303030"}}>DESTRIBUTION BBUSINESS INQUIRY FORM</h2>
//                 </div>
//                 <p style={{paddingLeft:"15px",fontSize:"14px"}}>
//                 Grow your business as a distributor with J. products range. Fill out the inquiry form and we will be in touch within 24 hours.</p>
//                 <Row style={{marginTop:"50px"}}>
//                     <Col>
//                     <div class="form-group" >
//                                     <input  type="text" name="" class="form-control" id="" placeholder= "Business Name *"/>
//                                 </div><br />
//                                 <div class="form-group">
//                                     <input  type="text" name="" class="form-control" id="" placeholder="Your Name *" />
//                                 </div><br />
//                                 <div class="form-group">
//                                     <input  type="text" name="" class="form-control" id="" placeholder="Your Contact Number *"/>
//                                 </div><br />
//                                 <div class="form-group">
//                                     <input  type="text" name="" class="form-control" id="" placeholder="Your Country *"/>
//                                 </div>
                    
                    
//                     </Col>
//                     <Col>
//                     <div class="form-group">
//                                     <input  type="text" name="" class="form-control" id="" placeholder="Your City *" />
//                                 </div><br />
//                                 <div class="form-group">
//                                     <input  type="text" name="" class="form-control" id="" placeholder="Your Email *" /></div>
//                                     <br />
//                                     <div class="form-group">
//                                     <select id="category" name="category" class="form-control">
//                                         <option disabled="" selected="" value="">Select Category</option>
//                                         <option value="Apparel">Apparel</option>
//                                         <option value="Fragrances">Fragrances</option>
//                                         <option value="Cosmetics">Cosmetics</option>
//                                         <option value="Gift Box">Gift Box</option>
//                                     </select>
//                                 </div>    
//                                 <br />
//                                 <div class="form-group">
//                                     <input type="date" name="" class="form-control" id="" placeholder="Date *" />
//                                 </div>                            </Col>


// <label htmlFor="" style={{marginTop:"20px",textAlign:"left",}}><span style={{fontFamily:"Alata,sans serif",fontSize:"14px",color:"#9f9f9f"}}>Inquiry Detail</span></label>
// <br />
// <textarea typeof='text' placeholder='Write your text'></textarea>
// <br /><br />
// <div style={{}}>
// <button  className="bt" type='button' style={{fontFamily:"Alata,sans serif",marginTop:"20px",}}>SUBMIT</button></div>
//                 </Row></Col>
               
               
               
//                 <Col>
//                 <div className="Ima"style={{marginLeft:"30px", marginTop:"30px"}}>
//             <img style={{width:"100%",height:"auto"}}src="https://www.junaidjamshed.com/media/CorporateImages/default/corporate.jpg"  alt="" /></div>
//                 </Col>


     

//             </Row>
//         </Container>
//         <Useletter/>
//         <Foter/>
//     </div>
//   )
// }

// export default Page2


import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';

function Page2() {
  return (
    <div>
      <Container fluid="md">
        <Row>
          {/* Left Section */}
          <Col xs={12} lg={8}>
            <div
              className="gift"
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                marginTop: "20px",
                gap: "10px",
              }}
            >
              <a
                href="/corporate"
                className="back-button"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  fontSize: "20px",
                }}
              >
                ←
              </a>
              <h2
                style={{
                  fontFamily: "Alata, sans serif",
                  fontSize: "22px",
                  color: "#303030",
                  margin: 0,
                }}
              >
                DISTRIBUTION BUSINESS INQUIRY FORM
              </h2>
            </div>

            <p
              style={{
                paddingLeft: "15px",
                fontSize: "14px",
                marginTop: "10px",
              }}
            >
              Grow your business as a distributor with J. products range. Fill
              out the inquiry form and we will be in touch within 24 hours.
            </p>

            {/* Form */}
            <Row style={{ marginTop: "40px" }}>
              <Col xs={12} md={6}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Business Name *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Contact Number *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Country *"
                  />
                </div>
              </Col>

              <Col xs={12} md={6}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your City *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Email *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <select id="category" name="category" className="form-control">
                    <option disabled selected value="">
                      Select Category
                    </option>
                    <option value="Apparel">Apparel</option>
                    <option value="Fragrances">Fragrances</option>
                    <option value="Cosmetics">Cosmetics</option>
                    <option value="Gift Box">Gift Box</option>
                  </select>
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Date *"
                  />
                </div>
              </Col>

              {/* Textarea */}
              <Col xs={12}>
                <label
                  style={{
                    marginTop: "20px",
                    display: "block",
                    fontFamily: "Alata, sans serif",
                    fontSize: "14px",
                    color: "#9f9f9f",
                  }}
                >
                  Inquiry Detail
                </label>
                <textarea
                  placeholder="Write your text"
                  style={{
                    width: "100%",
                    minHeight: "120px",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    resize: "vertical",
                  }}
                ></textarea>
                <br />
                <div style={{ textAlign: "center" }}>
                  <button
                    className="bt"
                    type="button"
                    style={{
                      fontFamily: "Alata, sans serif",
                      marginTop: "20px",
                      padding: "10px 25px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      background: "white",
                      cursor: "pointer",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "black";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "white";
                      e.target.style.color = "black";
                    }}
                  >
                    SUBMIT
                  </button>
                </div>
              </Col>
            </Row>
          </Col>

          {/* Right Side Image */}
          <Col xs={12} lg={4}>
            <div className="Ima" style={{ marginTop: "30px" }}>
              <img
                style={{ width: "100%", height: "auto", borderRadius: "8px" }}
                src="https://www.junaidjamshed.com/media/CorporateImages/default/corporate.jpg"
                alt=""
              />
            </div>
          </Col>
        </Row>
      </Container>

      <Useletter />
      <Foter />
    </div>
  );
}

export default Page2;
